import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
var resolveExtensions = [".js", ".jsx", ".ts", ".tsx"];
export function resolveImportSource(importSource, currentFilePath, files) {
  if (importSource.startsWith("/")) {
    // Absolute path
    return resolvePath(importSource, files);
  }
  if (importSource.startsWith("./") || importSource.startsWith("../")) {
    // Relative path
    var currentDir = currentFilePath.substring(0, currentFilePath.lastIndexOf("/"));
    var segments = currentDir ? currentDir.split("/") : [""];
    var parts = importSource.split("/");
    var _iterator = _createForOfIteratorHelper(parts),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var part = _step.value;
        if (part === ".") {
          continue;
        } else if (part === "..") {
          if (segments.length > 0) {
            segments.pop();
          }
        } else {
          segments.push(part);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return resolvePath(segments.join("/"), files);
  }

  // Bare module specifier
  return importSource;
}
function resolvePath(path, files) {
  if (files.some(function (f) {
    return f.filePath === path;
  })) {
    return path;
  }
  var _iterator2 = _createForOfIteratorHelper(resolveExtensions),
    _step2;
  try {
    var _loop = function _loop() {
        var ext = _step2.value;
        if (files.some(function (f) {
          return f.filePath === "".concat(path).concat(ext);
        })) {
          return {
            v: "".concat(path).concat(ext)
          };
        }
      },
      _ret;
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _ret = _loop();
      if (_ret) return _ret.v;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return path;
}
//# sourceMappingURL=resolveImportSource.js.map